export default "__VITE_ASSET__ad18bb31__"